export const ZendeskData = [
    {
        "category": "zendesk",
        "name": "The Trackman Support BOAT",
        "description": "<p><strong>BOAT</strong> is the overarching reporting framework and the name of the full reporting system.</p> <p>The Main Report is the surface-level view, focused on trends and for a quick overview of the past 7 days ticket amounts and last 30 days, comparing with same periods.</p> <p>Titles will navigate to SubMarine reports for each individual product. These are intended as deep dives when you want to go below the surface.</p>",
        "url": "https://trackman.zendesk.com/explore/studio#/dashboards/BEAA195B454A04D6BAC7DC64DE86A06098C4A96262CA0FEDEA2D91D50307DF9E"
    }
]